import { PRODUCT_CATEGORY_ADD, PRODUCT_CATEGORY_VIEW, PRODUCT_ADD, PRODUCT_VIEW, PRODUCT_EDIT, PRODUCT_PRINT_LABEL, PRODUCT_IMPORT } from '@/utils/permissions'

export default [
  {
    path: '/products/list',
    name: 'product-list',
    component: () => import('@/views/products/ProductList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Product List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Product' }, { title: 'Product List', active: true }],
      permissions: [PRODUCT_VIEW]
    }
  },
  {
    path: '/products/create',
    name: 'product-create',
    component: () => import('@/views/products/AddProduct.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Product',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Product', url: '/products/list' },
        { title: 'Add Product', active: true }
      ],
      permissions: [PRODUCT_ADD]
    }
  },
  {
    path: '/category/list',
    name: 'category-list',
    component: () => import('@/views/products/CategoryList.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Category List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Product Category' }, { title: 'Category List', active: true }],
      permissions: [PRODUCT_CATEGORY_VIEW]
    }
  },
  {
    path: '/category/create',
    name: 'create-category',
    component: () => import('@/views/products/AddCategory.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Category',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'category', url: '/category/list' },
        { title: 'Create Category', active: true }
      ],
      permissions: [PRODUCT_CATEGORY_ADD]
    }
  },
  {
    path: '/category/:id/edit',
    name: 'edit-category',
    component: () => import('@/views/products/EditCategory.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Category',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Category List', url: '/category/list' },
        { title: 'Category-edit', active: true }
      ]
    }
  },
  {
    path: '/products/:id/historical-change',
    name: 'edit-product-historical-change',
    component: () => import('@/views/products/ProductHistoricalChange.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Product Historical List',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Product List', url: '/products/list' },
        { title: 'Historical Change List', active: true }
      ],
      permissions: [PRODUCT_VIEW]
    }
  },
  {
    path: '/products/:id/edit',
    name: 'edit-product',
    component: () => import('@/views/products/EditProduct.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Product',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Product List', url: '/products/list' },
        { title: 'Edit Product', active: true }
      ],
      permissions: [PRODUCT_EDIT]
    }
  },
  {
    path: '/products/:id/label',
    name: 'product-label',
    component: () => import('@/views/products/ProductLabel.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Product Label',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Product List', url: '/products/list' },
        { title: 'Product Label', active: true }
      ],
      permissions: [PRODUCT_PRINT_LABEL]
    }
  },
  {
    path: '/products/import',
    name: 'import-products',
    component: () => import('@/views/products/ImportProduct.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Import Product',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Product List', url: '/products/list' },
        { title: 'Import Product', active: true }
      ],
      permissions: [PRODUCT_IMPORT]
    }
  }
]
